import { useMutation, useQueryClient } from "react-query";

import { crearRegistroPago, updateRegistroPago, deleteRegistroPago} from '../../services/RegistroPagos';

import { toast } from 'react-hot-toast';
const queryKey = "pagos";

export const usePagosMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addPago = useMutation((body) => crearRegistroPago(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updatePagoC = useMutation(
    (body) => updateRegistroPago( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removePago = useMutation((id) => deleteRegistroPago( id), {
    onSuccess,
    onError,
  });

  return { addPago, updatePagoC, removePago };
};
export default usePagosMutations;